IpixJson.options.owlcarousel = {
    loop: true,
    margin: 20,
    items: 1,
    dots: false,
    autoplay: true,
    nav: true,
    navText: ["<i class='fa-solid fa-arrow-left'></i>", "<i class='fa-solid fa-arrow-right'></i>"],
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
        },
        800: {
            items: 2,
        },
        1000: {
            items: 3,
        }
    }
}